import InfoReportByDay from './InfoReportByDay';

export default InfoReportByDay;
